import { FC } from "react"
import { Top } from "../../layout/desktop/Top"
import { useConfiguration } from "../../hooks/useConfiguration";
import { TeamHeader } from "../../layout/desktop/TeamHeader";
import Menu from "../../layout/legacy/menu";
import { TeamTitle } from "../../components/layout/TeamTitle";
import { TeamContext } from "../../types/common";

export const LegacyDesktopHeader: FC = () => {
    const config = useConfiguration();
    return (
        <>
            <Top />
            <TeamHeader />
            <Menu teamContext={config.teamName} standalone={config.standalone} />
        </>
    );
}

export const HeaderTeamTitleWidget: FC = () => {
    const config = useConfiguration();

    let title = '«РОДИНА»';
    let subtitle = 'Футбольный клуб';
    let bottomTitle = '';
    let url = '/';

    if (config.teamName === TeamContext.RODINA_2) {
        title = '«РОДИНА-2»';
        url = '/2/';
    } else if (config.teamName === TeamContext.RODINA_3) {
        title = '«РОДИНА-3»';
        url = '/3/';
    } else if (config.teamName === TeamContext.RODINA_M) {
        bottomTitle = 'Молодёжка';
        title = 'ФК «РОДИНА»';
        subtitle = '';
        url = '/youth/';
    } else if (config.teamName === TeamContext.ACADEMY) {
        subtitle = 'Академия';
    }
    return <TeamTitle title={title} subtitle={subtitle} bottomTitle={bottomTitle} url={url} />
}